import React from 'react';
import { CheckIcon, GlobeIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { MOCKUP_URL, valueStack } from '../../data/content';
export function Offer() {
  return <section id="offer" className="bg-ink-950 px-3 py-16 md:px-8 md:py-24" data-id="element-220" data-mp="357f7222mevdm">
      <div className="mx-auto max-w-3xl" data-id="element-221" data-mp="3a5yt02h7s75z">
        <div className="px-1 text-center text-white" data-id="element-222" data-mp="3a56uojw8fvc0">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-300" data-id="element-223" data-mp="3f407ea3p3ib4">Your complete endodontic retreatment decision system</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight md:text-[42px]" data-id="element-224" data-mp="3jw1u6pyhorfe">
            6 Clinical Volumes + 5 Practical Bonuses
          </h2>
          <p className="mt-3 text-[17px] text-mist-200" data-id="element-225" data-mp="3swzpmjuv3qmd">Everything organized into one digital toolkit.</p>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_rgba(0,0,0,0.4)] ring-4 ring-cta-400" data-id="element-226" data-mp="1q59derl6fkp">
          <div className="bg-cta-400 py-2.5 text-center text-sm font-extrabold uppercase tracking-wide text-ink-950" data-id="element-227" data-mp="1kj3urib34tv7">
            Special launch offer — today only
          </div>
          <div className="p-5 md:p-10" data-id="element-228" data-mp="1bl1zlje18vfu">
            <img src={MOCKUP_URL} alt="Complete Endodontic Retreatment Decision Blueprint bundle" className="mx-auto w-full max-w-md" data-id="element-229" data-mp="16lytrwq8al6t" />

            <p className="mt-6 text-sm font-extrabold uppercase text-ink-900" data-id="element-230" data-mp="23aoavku179rq">Here's what you get:</p>
            <ul className="mt-3 divide-y divide-mist-100" data-id="element-231" data-mp="1zbnsu4jdob5s">
              {valueStack.map(v => <li key={v.label} className="flex items-start justify-between gap-3 py-3" data-id="element-232" data-mp="1uicvcu0gh6qj">
                  <span className="flex items-start gap-2.5 text-[15px] font-semibold leading-snug text-ink-800" data-id="element-233" data-mp="1pjrvwwt12r35">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-234" data-mp="2n1i5om3p5zq1" />
                    {v.label}
                  </span>
                  <span className="shrink-0 text-[15px] font-bold text-mist-500 line-through" data-id="element-235" data-mp="316ihifq0keee">{v.value}</span>
                </li>)}
            </ul>

            <div className="mt-6 rounded-2xl bg-mist-50 p-5 text-center" data-id="element-236" data-mp="2sd5eum25dyf4">
              <p className="text-[16px] font-bold text-mist-600" data-id="element-237" data-mp="2sb2sqd448pfo">
                Total reference value: <span className="text-red-600 line-through" data-id="element-238" data-mp="2wcxsveab8wrv">$333</span>
              </p>
              <p className="mt-2 text-sm font-extrabold uppercase text-ink-900" data-id="element-239" data-mp="2idekqlhi1lfk">Today, just</p>
              <p className="text-[76px] font-extrabold leading-none tracking-tight text-ink-900 md:text-[96px]" data-id="element-240" data-mp="2nevjobgfaxti">
                $27
              </p>
              <p className="mt-2 text-[15px] font-bold text-brand-700" data-id="element-241" data-mp="2dfwifdxzm4gj">One payment. Instant digital access.</p>
              <p className="mt-1 text-sm text-mist-600" data-id="element-242" data-mp="7meqwa3zo07c">No subscriptions · No recurring charges · No unnecessary theory</p>
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-brand-200/50 p-4" data-id="element-243" data-mp="bnzzvkdejuc9">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-700" aria-hidden="true" data-id="element-244" data-mp="1w7dl8h1o7996" />
              <p className="text-[14px] font-semibold leading-snug text-ink-900" data-id="element-245" data-mp="1s6a3fp02b35b">
                Price in USD. <strong data-id="element-246" data-mp="25x5gzelia8f8">Currency conversion is automatic</strong> — at checkout you'll see the amount in
                your local currency.
              </p>
            </div>

            <div className="mt-5" data-id="element-247" data-mp="2fu1phkbemujs">
              <ScarcityBar data-id="element-248" data-mp="2ft05gqceuxpx" />
            </div>

            <div className="mt-6" data-id="element-249" data-mp="2avqhlf4o6u47">
              <CtaButton label="Yes! Give me the complete blueprint for $27" data-id="element-250" data-mp="2auf60t4zgi2j" />
            </div>

            <Countdown tone="light" data-id="element-251" data-mp="2ou6ob62j8kmc" />

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-semibold text-mist-600" data-id="element-252" data-mp="2ot59cqiebdzc">
              <span className="flex items-center gap-1.5" data-id="element-253" data-mp="ugyrx9yws0yl"><LockIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-254" data-mp="uhqk0atargk4" />Secure Checkout</span>
              <span className="flex items-center gap-1.5" data-id="element-255" data-mp="pjor6y62k2vg"><ZapIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-256" data-mp="rx2csmjlsbm5" />Instant Access</span>
              <span className="flex items-center gap-1.5" data-id="element-257" data-mp="vy42abnpx9ax"><ShieldCheckIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-258" data-mp="vx2ow0j8caq1" />7-Day Guarantee</span>
            </div>
            <p className="mt-5 text-center text-xs text-mist-500" data-id="element-259" data-mp="10vdz4cdfsn8s">
              Reference values are illustrative component valuations, not verified previous selling prices.
            </p>
          </div>
        </div>
      </div>
    </section>;
}